import React from 'react'
import { StyleGetInTouchWrapper } from './style'
import { StyleText } from '@pages/front/commons/Text/style'
import {
  CallIcon,
  EmailIcon,
  FacebookIcon,
  InstagramIcon,
  LocationIcon,
  TwitterIcon,
} from '@pages/front/svgs/svg'
import { StyleSvgWrappeer } from '@pages/front/commons/SvgIcon/style'

const FooterGetInTouchSection = () => {
  return (
    <StyleGetInTouchWrapper>
      <StyleText weight="600" color="#262f77" flex>
        Get In Touch
      </StyleText>
      <StyleText weight="300" flex>
        <StyleSvgWrappeer dangerouslySetInnerHTML={{ __html: EmailIcon }} />
        Contact@Supachar.com
      </StyleText>
      <StyleText weight="300" flex>
        <StyleSvgWrappeer dangerouslySetInnerHTML={{ __html: CallIcon }} />
        01-5913729 | 01-5913728
      </StyleText>
      <StyleText weight="300" flex>
        <StyleSvgWrappeer dangerouslySetInnerHTML={{ __html: LocationIcon }} />
        Kathmandu, Nepal
      </StyleText>

      <StyleText weight="300" flex>
        Connect with Us:
        <StyleSvgWrappeer dangerouslySetInnerHTML={{ __html: FacebookIcon }} />
        <StyleSvgWrappeer dangerouslySetInnerHTML={{ __html: InstagramIcon }} />
        <StyleSvgWrappeer dangerouslySetInnerHTML={{ __html: TwitterIcon }} />
      </StyleText>
    </StyleGetInTouchWrapper>
  )
}

export default FooterGetInTouchSection
